export default __webpack_public_path__ + "static/media/HIGH ANKLE BOOT.fda87f77.jpg";